import { useEffect } from 'react'
import { ACTIVITY_THROTTLE, LAST_ACTIVITY_KEY } from './constants'
import type { SessionState } from './reducer'

export function useActivityTracker(isActive: boolean, stateRef: React.RefObject<SessionState>) {
  useEffect(() => {
    if (!isActive) return

    let lastWrite = Date.now()

    const handleActivity = () => {
      if (stateRef.current.status !== 'active') return
      const now = Date.now()
      if (now - lastWrite < ACTIVITY_THROTTLE) return
      lastWrite = now
      localStorage.setItem(LAST_ACTIVITY_KEY, String(now))
    }

    const events = ['pointerdown', 'keydown', 'scroll', 'touchstart'] as const
    const options: AddEventListenerOptions = { passive: true }
    events.forEach((e) => window.addEventListener(e, handleActivity, options))

    return () => {
      events.forEach((e) => window.removeEventListener(e, handleActivity))
    }
  }, [isActive, stateRef])
}
